module.exports = __webpack_public_path__ + "static/media/waterKeepBack.0d570d97.png";